// import { ENV } from '../utils/constants';
import configJson from '../config.json';

// const config = {};

// if (process.env.REACT_APP_ENV === ENV.PRODUCTION.KEY) {
//   config = require('./config.prod.js'); // eslint-disable-line global-require
// } else if (process.env.REACT_APP_ENV === ENV.DEVELOPMENT.KEY) {
//   config = require('./config.dev.js'); // eslint-disable-line global-require
// } else {
//   config = require('./config.local.js'); // eslint-disable-line global-require
// }

const config = {
  debugMode: configJson.debugMode,
  URI: configJson.URI,
  apiKey: configJson.apiKey,
  authDomain: configJson.authDomain,
  databaseURL: configJson.databaseURL,
  projectId: configJson.projectId,
  storageBucket: configJson.storageBucket,
  messagingSenderId: configJson.messagingSenderId,
  appId: configJson.appId,
  measurementId: configJson.measurementId,
};

export default config;
